import { useEffect } from "react";
import filterTag from "./functions/filterTag";
import fillContent from "./functions/fillContent";
import "./css/default.scss";
import "./css/magnific-popup.scss";
import "./css/layout.scss";
import "./css/media-queries.scss";
// import "./js/init";
import Header from "./components/header";
import About from "./components/about";
import Education from "./components/education";
import Projects from "./components/projects";
import Experience from "./components/experience";
import Skills from "./components/skills";
import Languages from "./components/languages";
import Recommendation from "./components/recommendation";
import Contact from "./components/contact";
import Footer from "./components/footer";

function Theme1({ data, subdomain }) {
  useEffect(() => {
    let metaTags = document.getElementsByTagName("meta");
    let description = filterTag(metaTags, "description");
    let author = filterTag(metaTags, "author");

    fillContent(author, data.name);
    fillContent(description, data.about);
    document.title = data.name + " | SitesGPT";
  }, [data.name, data.about]);

  return data && (
    <div id="theme1">
      <Header data={data} />

      <About data={data} subdomain={subdomain} />
      <section id="resume">
        {data.education?.length > 0 && Object.keys(data.education[0]).length > 0 ? <Education data={data} /> : <></>}
        {data.workExperience?.length > 0 && Object.keys(data.workExperience[0]).length > 0 ? <Experience data={data} /> : <></>}
        {data.skills?.length > 0 && Object.keys(data.skills[0]).length > 0 ? <Skills data={data} /> : <></>}
        {data.languages?.length > 0 && Object.keys(data.languages[0]).length > 0 ? <Languages data={data} /> : <></>}
      </section>
      {data.projects?.length > 0 && Object.keys(data.projects[0]).length > 0 ? <Projects data={data} /> : <></>}

      {data.recommendations?.length > 0 && Object.keys(data.recommendations[0]).length > 0 ? <Recommendation data={data} /> : <></>}

      <Contact data={data} />
      <Footer data={data} />
    </div>
  );
}
export default Theme1;
